import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";
import { orderEventIdZodSchema } from "../../order-events/events/_order-event-id";
import { orderIdZodSchema } from "../../order-id";
import { orderReceiptProjectionZodObject } from "./order-receipt.projection";
import { orderReceiptsProjectionIdZodSchema } from "./order-receipts-projection-id";

const receiptsProjectionZodObject = z.object({
    _id: orderReceiptsProjectionIdZodSchema,
    _type: z.literal("RECEIPTS_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    receiptsFor: z.object({
        providerId: providerIdZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
    }),
    paymentEventIds: z.array(orderEventIdZodSchema),
    receipts: z.array(orderReceiptProjectionZodObject),
    // All receipts, including the original receipt:
    // changeReceipts: z.array(orderReceiptProjectionZodObject),
    // Only the original receipt, still part of the receipts array as well:
    // originalReceipt: orderReceiptProjectionZodObject,
});
type ReceiptsProjection = z.infer<typeof receiptsProjectionZodObject>;
const receiptsProjectionZodSchema =
    receiptsProjectionZodObject as z.ZodSchema<ReceiptsProjection>;

export { receiptsProjectionZodObject, receiptsProjectionZodSchema };
export type { ReceiptsProjection };
